export const FINANCIAL_STATEMENT_DOC_TYPE_ID = "financial-statement";
export const AUDITED_FINANCIALS_DOC_TYPE_ID = "audited-financials";
export const MANAGEMENT_FINANCIALS_DOC_TYPE_ID = "management-financials";
export const FINANCIAL_REPORT_DOC_TYPE_ID = "financial-report";

export const FINANCIAL_DOC_TYPE_IDS = [
  FINANCIAL_REPORT_DOC_TYPE_ID,
  FINANCIAL_STATEMENT_DOC_TYPE_ID,
  AUDITED_FINANCIALS_DOC_TYPE_ID,
  MANAGEMENT_FINANCIALS_DOC_TYPE_ID,
] as const;

export const FINANCIAL_DOC_TYPES = new Set<string>(FINANCIAL_DOC_TYPE_IDS);

export const FINANCIAL_PARENT_COMPATIBLE_DOC_TYPE_IDS = [
  FINANCIAL_REPORT_DOC_TYPE_ID,
  AUDITED_FINANCIALS_DOC_TYPE_ID,
  MANAGEMENT_FINANCIALS_DOC_TYPE_ID,
] as const;

export const FINANCIAL_PARENT_COMPATIBLE_DOC_TYPES = new Set<string>(
  FINANCIAL_PARENT_COMPATIBLE_DOC_TYPE_IDS,
);

/** Normalise document labels for tolerant id/name matching (spacing, casing, slashes). */
export const normalizeDocumentLabel = (value?: string | null): string =>
  (value ?? "").toLowerCase().replace(/[^a-z0-9]/g, "");

/**
 * Pairs a financial sub-item's canonical slot id (key) with the normalized
 * label keyword used for tolerant label/name matching, so the two are defined
 * together instead of as separate loose string constants.
 */
export type FinancialSubItemDescriptor = {
  /** Canonical document_type / slot id. */
  id: string;
  /** Keyword present in a normalized display label/name for this sub-item. */
  labelKeyword: string;
};

export const FINANCIAL_SUBITEM_DESCRIPTORS: Record<
  "audited" | "management",
  FinancialSubItemDescriptor
> = {
  audited: {
    id: AUDITED_FINANCIALS_DOC_TYPE_ID,
    labelKeyword: "auditedfinancial",
  },
  management: {
    id: MANAGEMENT_FINANCIALS_DOC_TYPE_ID,
    labelKeyword: "managementfinancial",
  },
};
